
export default () => ({
  // AI TOOLS (历史原因，借鉴了上一位同事的，因此没有把state合并)
  // 详情
  bgRemoveDetail: {},
  colorizeDetail: {},
  enhancerDetail: {},
  enlargerDetail: {},

  // 展开项
  bgRemoveActives: [],
  colorizeActives: [],
  enhancerActives: [],
  enlargerActives: [],

  // 图片列表 
  bgRemoveImages: [],
  colorizeImages: [],
  enhancerImages: [],
  enlargerImages: [],

  // 缓存
  bgLargeItem: null,
  bgremoveItem: null,
  colorizeItem: null,
  enhancerItem: null,
  enlargerItem: null,
  resizeItem: null,
  editorItem: null,
  filpItem: null,
  rotateItem: null,
  convertetItem: null,
  compressorItem: null,

  signCache: null,
  downloadSignCache: null,

  // Edit Tools
  converter: null,
  compressor: null,
  editor: null,
  resize: null,
  flip: null,
  rotate: null,
})
